<form [formGroup]="eligibilityForm" (ngSubmit)="onSubmit(eligibilityForm.value)">
  <div class="form-field single-value">
    <label>
      <span class="form-label">{{ formValues.label }}</span>
      <input
        class="single-value-form"
        type="text"
        [placeholder]="formValues.placeholder"
        required
        [formControlName]="formValues.controlName"
        [id]="formValues.controlName" />
    </label>
  </div>
  <kp-eligibility-error *ngIf="error"></kp-eligibility-error>
  <div class="button-row" *ngIf="groupValidationBloc.groupValidationDataStatus$ | async as groupValidationStatus">
    <a
      class="button button-secondary button-pill button-eligibility"
      routerLink="/welcome/eligibility"
      *ngIf="groupValidationStatus?.data?.eligibilityVerificationTypes?.length > 1"
      (click)="switchToAnotherMethod()">
      Try Another Method
    </a>
    <button
      class="button button-pill button-eligibility"
      type="submit"
      [disabled]="!eligibilityForm.valid || loading || error">
      Continue
    </button>
  </div>
</form>
